import { useCallback, useMemo } from 'react';
import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { BannerNotification, Button, Text } from '@frontend/design-system';
import { insuranceTabTrackingIds } from '../tracking-ids';

interface InsuranceCardBannerNotificationProps {
  enhancedVerificationInprogress: boolean;
  isEligibleForWebsiteResp: boolean;
}

export const InsuranceCardBannerNotification = ({
  enhancedVerificationInprogress,
  isEligibleForWebsiteResp,
}: InsuranceCardBannerNotificationProps) => {
  const { t } = useTranslation();

  const navigateToPayerConnectionManagement = useCallback(() => {
    window.location.hash = 'settings/insurance/payer-connection-management';
  }, []);

  const payerNotConnectedMessage = useMemo(
    () => (
      <>
        <Text>{t('Currently showing EDI responses. Add payer credential for a detailed eligibility report')}</Text>
        <Button
          css={{ marginTop: theme.spacing(1), padding: 0 }}
          iconName='plus'
          variant='tertiary'
          trackingId={insuranceTabTrackingIds.addPayerConnectionButton}
          onClick={navigateToPayerConnectionManagement}
        >
          {t('Add Payer Credential')}
        </Button>
      </>
    ),
    [t, navigateToPayerConnectionManagement]
  );

  if (enhancedVerificationInprogress) {
    return (
      <BannerNotification
        css={commonBannerStyles}
        status='warn'
        message={t("We're currently retrieving your report. This may take 1-2 minutes.")}
      />
    );
  }

  if (isEligibleForWebsiteResp) {
    return <BannerNotification css={commonBannerStyles} status='warn' message={payerNotConnectedMessage} />;
  }

  return null;
};

const commonBannerStyles = css({ margin: theme.spacing(2, 0), alignItems: 'flex-start' });
